var _circle, _circle2, _circle3, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgChangePassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 151,
    viewBox: "0 0 154 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 77,
    cy: 75.5,
    r: 70,
    stroke: "#C9FAC5",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.34,
    cx: 77,
    cy: 75.5,
    r: 75,
    stroke: "#C9FAC5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 75.5,
    r: 63.5,
    stroke: "#C9FAC5",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 75C16.5 41.8629 43.3629 15 76.5 15C109.637 15 136.5 41.8629 136.5 75C136.5 108.137 109.637 135 76.5 135C43.3629 135 16.5 108.137 16.5 75Z",
    fill: "#20B970"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1408_64673)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.779 96.4254C105.913 96.4254 108.452 93.8678 108.452 90.7112C108.452 87.5545 105.913 84.9969 102.779 84.9969C99.6446 84.9969 97.1054 87.5545 97.1054 90.7112C97.1054 93.8678 99.6446 96.4254 102.779 96.4254ZM92.5652 90.7112C92.5652 85.0293 97.1375 80.4238 102.779 80.4238C108.42 80.4238 112.992 85.0293 112.992 90.7112C112.992 96.3931 108.42 100.998 102.779 100.998C97.1375 100.998 92.5652 96.3931 92.5652 90.7112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8429 94.1027C84.642 93.0019 84.5295 91.8688 84.5295 90.7114C84.5295 80.5778 92.7179 72.3301 102.779 72.3301C104.675 72.3301 106.507 72.6215 108.227 73.1638V70.509C108.227 65.8874 104.498 62.1318 99.9098 62.1318H58.317C53.7205 62.1318 50 65.8874 50 70.509V95.6486C50 100.27 53.7205 104.026 58.317 104.026H75.1759C75.4813 103.605 75.8187 103.192 76.1964 102.804L84.8429 94.0946V94.1027Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M69.317 55.8507C69.317 50.0635 73.9696 45.3772 79.7152 45.3772C85.4607 45.3772 90.1134 50.0635 90.1134 55.8507V62.1315H98.4304V55.8507C98.4304 45.4419 90.0491 37 79.7152 37C69.3813 37 61 45.4419 61 55.8507V62.1315H69.317V55.8507Z",
    fill: "url(#paint0_linear_1408_64673)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M97.3384 99.4205L91.2393 105.572L94.1723 108.526C95.0563 109.416 95.0563 110.865 94.1723 111.756C93.2884 112.646 91.85 112.646 90.9661 111.756L88.033 108.801L86.6991 110.137L89.6322 113.091C90.5161 113.981 90.5161 115.43 89.6322 116.32C88.7482 117.211 87.3098 117.211 86.4259 116.32L81.8857 111.747C81.0018 110.857 81.0018 109.408 81.8857 108.518L94.1402 96.1748C94.9598 97.4779 96.0527 98.5787 97.3464 99.4043L97.3384 99.4205Z",
    fill: "url(#paint1_linear_1408_64673)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1408_64673",
    x1: 79.7152,
    y1: 37,
    x2: 79.7152,
    y2: 62.1315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1408_64673",
    x1: 97,
    y1: 97.5,
    x2: 83,
    y2: 112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1408_64673"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 80,
    fill: "white",
    transform: "translate(50 37)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgChangePassword);
export default __webpack_public_path__ + "static/media/img_change_password.9a0d72022a4286b0b7013134a7a94527.svg";
export { ForwardRef as ReactComponent };